(function($){

  var klv = {
    v: {
      rsrw: '.kl_reviews__star_rating_widget',
      prws: '#klaviyo-product-reviews-wrapper > .kl_reviews__summary',
      onhover: false,
      onhovergen: false,
    }, 
    f: {
      genRHover: () => {
        if(klv.v.onhovergen){
          return null;
        }

        $(klv.v.rsrw).parent().css('position', 'relative');
        $(klv.v.rsrw).after('<div class="klv-review-summary" style="display:none;"><div>' + $(klv.v.prws)[0].outerHTML + '</div><div class="klv-view-customer-review-wrapper"><a href="#" id="klv-view-customer-review">See Customer Reviews</a></div></div>');
        klv.v.onhovergen = true;
      },
      onRShow: () => {
        $('.klv-review-summary').show();
        $('.klv-review-summary').css({opacity: 1, 'z-index': 1});
      },
      onRHide: () => {
        $('.klv-review-summary').css({opacity: 0, 'z-index': -1});
      }
    }
  };
  
  
  $(document)
  .on('click', '#klv-view-customer-review', function(e){
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $("#klaviyo-product-reviews-wrapper").offset().top
    }, 1000);
  })
  .on('mouseover', klv.v.rsrw, function(){
    if(!klv.v.onhover){
      klv.f.genRHover();
      klv.v.onhover = true;
    }

    klv.f.onRShow();
  })
  .on('click', 'body', function(){
    klv.v.onhover = false;
    klv.f.onRHide();
  });

  

  const targetNode = $('#MainContent .section:last-child');
  const config = { attributes: true, childList: true, subtree: true };

  const callback = (records) => {
    for (const record of records) {
      if (record.type === "childList") {
        for(let addedNode of record.addedNodes) {
          let node = $(addedNode);
    
          if(node.hasClass('reviews_all_container')) {
            let buttonNode = $('#MainContent .section:last-child').find(node).find('.kl_reviews__button_bar');
            
            buttonNode.find('.kl_reviews__button').text('');
            buttonNode.find('.kl_reviews__button').text('Review This Product');
            
            buttonNode.insertAfter($('#MainContent .section:last-child').find(node).find('.kl_reviews__answers_grid'));
  
            $('<p class="review-heading">Review this product</p><p class="review-subheading">Share your thoughts with other customers</p>').insertAfter($('#MainContent .section:last-child').find(node).find('.kl_reviews__answers_grid'));
          }
          
          if(addedNode.nodeValue == 'Write a review') {
            $(addedNode.parentNode).text('Review This Product');
          }
        }
      }
    }
  };

  const observer = new MutationObserver(callback);

  if(targetNode.get(0)) {
    observer.observe(targetNode.get(0), config);
  } else {
    observer.disconnect();
  }
  
})(jQuery);